/**
 * Wrap an unknown caught value into an `Error` instance.
 *
 * API clients may reject with plain objects that carry `detail` or `message`
 * fields instead of proper Error instances. This helper normalises them so
 * callers can always store an `Error`.
 */
export function wrapApiError(
    error: unknown,
    fallbackMessage = "An unexpected error occurred",
): Error {
    if (error instanceof Error) return error;
    if (typeof error === "object" && error !== null) {
        const obj = error as Record<string, unknown>;
        const msg =
            (typeof obj["detail"] === "string" && obj["detail"]) ||
            (typeof obj["message"] === "string" && obj["message"]);
        if (msg) return new Error(msg);
    }
    return new Error(String(error || fallbackMessage));
}
